"use client";
import { useEffect } from "react";

const SetDynamicHeight = () => {
  useEffect(() => {
    const updateHeight = () => {
      document.documentElement.style.setProperty(
        "--app-height",
        `${window.innerHeight}px`
      );
    };

    updateHeight(); // Set initial height
    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  return null; // This component only sets the CSS variable
};

export default SetDynamicHeight;
